import { AfterContentInit, Component, ContentChildren, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { CarouselSlideDirective } from '../../directives/carousel-slide.directive';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit, OnDestroy, AfterContentInit {

  public isLastPanel: boolean = false;

  @Input() moveToTop: boolean = false;
  @Input() showProgressDots: boolean = false;
  @Input() nextButtonName: string = 'Next';
  @Input() finalizationButtonName: string = 'Next';

  @Output() onFinalizationButtonClick: EventEmitter<void> = new EventEmitter();

  @ContentChildren(CarouselSlideDirective) slides!: QueryList<CarouselSlideDirective>;
  @ViewChild('swiperContainer', {static: true}) swiperContainer!: ElementRef<SwiperContainer>;

  private swiperParams!: SwiperOptions;

  constructor() {};

  public ngOnInit(): void {
    this.swiperParams = {
      slidesPerView: 1,
      pagination: {
        enabled: this.showProgressDots,
      },
      centeredSlidesBounds: true,
      longSwipes: false,
      shortSwipes: true,
    }
    this.swiperContainer.nativeElement.addEventListener('swiperprogress', this.onSwipeProgress.bind(this));
  }

  public ngAfterContentInit(): void {
    setTimeout(() => {
      Object.assign(this.swiperContainer.nativeElement, this.swiperParams);
      this.swiperContainer.nativeElement.initialize();
    }, 200);
  }

  public ngOnDestroy(): void {
    this.swiperContainer.nativeElement.removeEventListener('swiperprogress', this.onSwipeProgress);
  }

  public slideNext(): void {
    this.swiperContainer?.nativeElement?.swiper?.slideNext();
  }

  public onSwipeProgress(event: any): void {
    const [swiper, progress] = event.detail;
    this.isLastPanel = progress >= 1;
  }
}
